import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {withStyles} from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import InputLabel from '@material-ui/core/InputLabel'
import Visibility from '@material-ui/icons/Visibility'
import VisibilityOff from '@material-ui/icons/VisibilityOff'
import IconButton from '@material-ui/core/IconButton'
import green from '@material-ui/core/colors/green'
import FormControl from '@material-ui/core/FormControl'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import blue from '@material-ui/core/colors/blue'
import grey from '@material-ui/core/colors/grey'
import {FormattedMessage} from 'react-intl'
import {ContextConsumer} from '../Context'
import SpinnerSVG from '../assets/spinner'

const styles = theme => ({
  cardDesktop: {
    width: 280,
    alignSelf: 'center',
    position: 'relative',
    background: 'none',
    boxShadow: 'none',
  },
  cardMobile: {
    width: 280,
    alignSelf: 'center',
    position: 'relative',
    background: 'none',
    boxShadow: 'none',
  },
  logoWrapper: {
    width: 304,
    height: 80,
    margin: '20px auto 0',
  },
  container: {
    paddingRight: 10,
    paddingBottom: 10,
    paddingLeft: 10,
  },
  cardContent: {
    paddingTop: 0,
  },
  textField: {
    width: '100%',
  },
  button: {
    width: '100%',
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 10,
    background: `linear-gradient(to top, ${blue[900]}, ${blue[400]})`,
    '&:hover': {
      background: `linear-gradient(to top, ${blue[400]}, ${blue[900]})`,
    },
  },
  buttonLoading: {
    width: '100%',
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 10,
    background: `linear-gradient(to top, ${grey[900]}, ${grey[400]})`,
  },
  checked: {
    color: green[500],
    '& + $bar': {
      backgroundColor: green[500],
    },
  },
  bar: {},
  paper: {
    paddingRight: 20,
    paddingLeft: 20,
    marginTop: 20,
  },
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& $primary, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  primary: {},
  icon: {},
  notifyPaper: {
    backgroundColor: 'red',
    padding: 20,
    marginTop: 20,
  },
  notifyVPN: {
    backgroundColor: '#FB1',
    padding: 20,
    marginTop: 20,
  },
  notifyType: {
    color: 'white',
    fontSize: '1rem',
  },
  margin: {
    marginTop: 10,
  },
  switchLabel: {
    fontSize: '1rem',
  },
})

const Login = props => {
  const {classes} = props

  return (
    <ContextConsumer>
      {context => {
        const {
          isMobile,
          notify,
          username,
          password,
          showPassword,
          readonly,
          handleChange,
          handleKeyPress,
          handleClickShowPassword,
          handleMouseDownPassword,
          handleSendForm,
          handleRemoveAttribute,
        } = context
        return (
          <Card
            className={!isMobile ? classes.cardDesktop : classes.cardMobile}>
            <CardContent className={classes.cardContent}>
              {isMobile && notify && (
                <Paper className={classes.notifyPaper}>
                  <Typography
                    variant="body1"
                    align="center"
                    className={classes.notifyType}>
                    <FormattedMessage id="noMatch" />
                  </Typography>
                </Paper>
              )}

              <Fragment>
                <TextField
                  id="username-input"
                  label={<FormattedMessage id="username" />}
                  value={username}
                  onChange={handleChange('username')}
                  className={classes.textField}
                  type="text"
                  inputProps={{
                    autoCorrect: 'off',
                    autoCapitalize: 'none',
                  }}
                  margin="normal"
                  error={notify}
                  required
                  autoFocus
                  autoComplete="off"
                  readOnly={readonly}
                  onFocus={handleRemoveAttribute('readonly')}
                />

                <FormControl
                  className={classes.textField}
                  error={notify}
                  required>
                  <InputLabel htmlFor="adornment-password">
                    <FormattedMessage id="password" />
                  </InputLabel>
                  <Input
                    id="adornment-password"
                    type={showPassword ? 'text' : 'password'}
                    // style={{
                    //   WebkitTextSecurity: showPassword ? 'none' : 'dot',
                    // }}
                    autoCorrect="off"
                    autoCapitalize="none"
                    value={password}
                    onChange={handleChange('password')}
                    onKeyPress={handleKeyPress}
                    autoComplete="off"
                    readOnly={readonly}
                    onFocus={handleRemoveAttribute('readonly')}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="Toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}>
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Fragment>
            </CardContent>
            <CardActions>
              {context.loading ? (
                <Button
                  variant="raised"
                  size="large"
                  color="primary"
                  className={classes.buttonLoading}>
                  <SpinnerSVG />
                </Button>
              ) : (
                <Button
                  variant="raised"
                  size="large"
                  color="primary"
                  onClick={handleSendForm}
                  className={classes.button}>
                  <FormattedMessage id="logIn" />
                </Button>
              )}
            </CardActions>
          </Card>
        )
      }}
    </ContextConsumer>
  )
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles, {withTheme: true})(Login)



// WEBPACK FOOTER //
// ./src/components/Login.js